import i18n from '../i18n';

export const translate = i18n.t;
